import React, {useEffect, useState} from "react";
import {getLabel} from "../../../localization/MainLocalization";
import {material_table_localization} from "../../../components/Material_conf";
import Permissions from "../../../auth/permissions";
import Button from "@material-ui/core/Button";
import AddIcon from "@material-ui/icons/Add";
import Typography from "@material-ui/core/Typography";
import MaterialTable from "material-table";
import Grid from "@material-ui/core/Grid";
import {Hide} from "../../../components/Hide";
import {permissions_data} from "../../../auth/permission_data";
import {sub_directory} from "../../../App";
import {ActionButtons} from "../../../components/ActionButton";
import {httpRequestWithAuth} from "../../../auth/axios_instance";
import {BaseFinanceBankAccountAttachmentURL} from "../../../urls";
import {BankAccountAttachmentFormModal} from "./components/BankAccountAttachmentFormModal";
import {
    CreateBankAccountAttachments,
    DeleteBankAccountAttachments,
    UpdateBankAccountAttachments
} from "./bank_account_apis";


export const BankAccountAttachment = props => {
        const bank_account_id = props.bank_account_id;

            const columns =[
                {title: getLabel("name"), field: 'name'},
            ];
    const [attachments, setAttachments] = useState([])
    const [helper_text, setHelperText] = useState({})
    const [form_open, setFormOpen] = useState(false)
    const [form_data, setFormData] = useState({})
    const [is_loading, setIsLoading] = useState({})
    const [edit_attach, setEditAttach] = useState(true)


    const ListAttachmentsData = async () => {
       await setIsLoading(true)

        let ListPaymentsResponse = await httpRequestWithAuth(BaseFinanceBankAccountAttachmentURL, "GET", null, {bank_account : bank_account_id});
        if (ListPaymentsResponse.status) {
           await setAttachments(ListPaymentsResponse.data)
        }

        await setIsLoading(false)
    };

    useEffect(()=>{
        ListAttachmentsData();
    },[])

    const onChangeHandle = (name, value) =>{
        setFormData({...form_data, [name]: value});
    }

    const handleModalOpen = (data, edit) => {
        setEditAttach(edit)
        setFormData(data)
        setFormOpen(true)
    };

    const handleModalClose = async () => {
        await ListAttachmentsData();
        await setHelperText({});
        setFormData({})
        setFormOpen(false)
    };


    const handleBackButton = () => {
        props.history.push(sub_directory + "bank-accounts")
    }

    const handleSaveModal = async () => {
        await setIsLoading(true);

        let response;

        if (form_data.id === undefined){
             response = await CreateBankAccountAttachments({bank_account:bank_account_id, ...form_data});
        }else{
             response = await UpdateBankAccountAttachments(form_data.id, {name:form_data.name});
        }

        if (response.status){
            await handleModalClose();
        }else {
            setHelperText(response.error_feedback);
        }

        await setIsLoading(false);
    };


        return(
            <>
                    <Hide hide={!form_open}>
                        <BankAccountAttachmentFormModal
                        open={form_open}
                        handleModalClose={handleModalClose}
                        data={form_data}
                        handleSaveForm={handleSaveModal}
                        helper_text={helper_text}
                        onChangeHandle={onChangeHandle}
                        is_loading={is_loading}
                        edit_attach={edit_attach}
                        />
                    </Hide>

                <Grid item xs={12}>
                    <MaterialTable
                        style={{padding: '0.5rem', boxShadow: "none"}}
                        is_loading={is_loading}
                        columns={columns}
                        data={attachments}
                        onRowClick={(event, rowData) => window.open(rowData.file)}
                        editable={Permissions.checkPermission(permissions_data.bank_account_attachment.delete) && !props.is_closed && {
                                onRowDelete: async attachmentData => {
                                    await DeleteBankAccountAttachments(attachmentData.id);
                                    await ListAttachmentsData();
                                }
                        }}

                        actions={[
                            {
                            icon:()=> (
                                    <Button key="0" size="small" variant="contained" className='mt-2' color='primary'
                                            startIcon={<AddIcon/>}>
                                        <Typography variant="body1">{getLabel('add_attachment')}</Typography>
                                    </Button>
                                ),
                                hidden: !Permissions.checkAllPermissions([permissions_data.bank_account_attachment.add]) || props.is_closed,
                                isFreeAction: true,
                                onClick: () => handleModalOpen({},true)
                            },
                            {
                                icon: () => (
                                    <Button  size="small"
                                             color="primary"
                                             variant="outlined">
                                        {getLabel("view_file")}
                                    </Button>
                                ),
                                tooltip:getLabel('view_file'),
                                onClick: (event, rowData) => window.open(rowData.file)
                            },
                            {
                                icon: 'edit',
                                tooltip:getLabel('edit_attachment'),
                                hidden: !Permissions.checkAllPermissions([permissions_data.bank_account_attachment.change]) || props.is_closed,
                                onClick: (event, rowData) => handleModalOpen(rowData,false)
                            }
                        ]}

                        options={{
                            actionsColumnIndex: -1,
                            search: false,
                            paging: false,
                            showTitle: false
                        }}

                        {...material_table_localization()}
                    />
                </Grid>


                <ActionButtons
                    allowBack={true}
                    backAction={handleBackButton}
                />
                </>
        );

}
